module.exports = __webpack_public_path__ + "media/images/apple-store-badge-20c3995e91dfde72283f793b981b6d77.svg";